import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=3a779f6f&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"
import style0 from "./layout.vue?vue&type=style&index=0&id=3a779f6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a779f6f",
  null
  
)

export default component.exports